import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { BaseService } from '../base/base.service';
import { SessionUserHashManagerService } from '../session-user-hash-manager/session-user-hash-manager.service';
import { SubmitFeedbackResponse } from '../../_models/student-feedback/submit-feedback-response.model';
import { ExternalStudentQuestionnaireInfoRequest } from '../../_models/student-feedback/external-student-questionnaire-info-request.model';
import { GenerateFeedbackLinkResponse } from '../../_models/student-feedback/generate-student-feedback-link-response.model';
import { FeedbackSurvey } from '../../_models/student-feedback/feedback-survey.model';
import { SearchFeedbackDashboardData } from '../../_models/feedback-dashboard/search-feedback-dashboard-data.model';

@Injectable({
  providedIn: 'root'
})
export class StudentFeedbackService extends BaseService {

  private apiUrl: string = environment.apiUrl;

  constructor(
    private http: HttpClient, 
    protected hashManagerService: SessionUserHashManagerService
    ) {
    super(hashManagerService);
    this.apiUrl += this.apiUrl.endsWith("/") ? "" : "/";
  }

  checkUserFeedbackSurveys(studentId: number) {
    return this.http.post(this.apiUrl + 'api/Feedback/CheckUserFeedbackSurveys', 
    {"Id": studentId},
    this.prepareOptions({"Id": studentId})).pipe(
      map((data: any) => {
        
        return data.body;
      }), catchError(this.handleError('checkUserFeedbackSurveys'))
    );
  }

  checkUserFeedbackSurveyOnLogin(studentId: number) {
    return this.http.post(this.apiUrl + 'api/Feedback/CheckUserFeedbackSurveyOnLogin', 
    {"Id": studentId},
    this.prepareOptions({"Id": studentId})).pipe(
      map((data: any) => {
        
        return data.body;
      }), catchError(this.handleError('checkUserFeedbackSurveyOnLogin'))
    );
  }

  requestTuitionFeedbackSurvey(studentId: number, placementId: number, placementStartDate: Date, placementEndDate: Date) {
    return this.http.post(this.apiUrl + 'api/Feedback/RequestTuitionFeedbackSurvey', 
    {"Id": studentId, "PlacementId": placementId, "PlacementStartDate": placementStartDate, "PlacementEndDate": placementEndDate},
    this.prepareOptions({"Id": studentId, "PlacementId": placementId, "PlacementStartDate": placementStartDate, "PlacementEndDate": placementEndDate})).pipe(
      map((data: any) => {
        
        return data.body;
      }), catchError(this.handleError('requestTuitionFeedbackSurvey'))
    );
  }

  public getStudentQuestionnaireInfoFromGuid(guid: string) {
    return this.http.post(this.apiUrl + 'api/Feedback/RequestTuitionFeedbackSurveyGuid', 
    {"value": guid},
    this.prepareAnonymousOptions({"value": guid})).pipe(
      map((data: any) => {
        
        return data.body;
      }), catchError(this.handleError('getStudentQuestionnaireInfoFromGuid'))
    );

  }

  saveFeedback(feedback: FeedbackSurvey) {
    return this.http.post(this.apiUrl + 'api/Feedback/SaveFeedback', 
    feedback,
    this.prepareOptions(feedback)).pipe(
      map((data: any) => {
        
        return data.body;
      }), catchError(this.handleError('saveFeedback'))
    );
  }

  emailFeedbackLink(studentId: number, placementId: number, placementStartDate: Date, placementEndDate: Date, customEmailAddress: string = "") {
    let payload = {"userId": studentId, "PlacementId": placementId, "PlacementStartDate": placementStartDate, "PlacementEndDate": placementEndDate, "EmailAddress": customEmailAddress};
    return this.http.post(this.apiUrl + 'api/Feedback/EmailStudentTuitionFeedbackLink', 
    payload,
    this.prepareOptions(payload)).pipe(
      map((data: any) => {
        
        return data.body;
      }), catchError(this.handleError('submitQuestionnaireFeedback'))
    );
  }

  generateFeedbackLink(studentId: number, placementId: number, placementStartDate: Date, placementEndDate: Date) {
    return this.http.post(this.apiUrl + 'api/Feedback/GenerateStudentTuitionFeedbackLink', 
    {"studentId": studentId, "PlacementId": placementId, "PlacementStartDate": placementStartDate, "PlacementEndDate": placementEndDate},
    this.prepareOptions({"studentId": studentId, "PlacementId": placementId, "PlacementStartDate": placementStartDate, "PlacementEndDate": placementEndDate})).pipe(
      map((data: any) => {
        
        return data.body;
      }), catchError(this.handleError('generateFeedbackLink'))
    );
  }

  getFeedbackDashboardData(search: SearchFeedbackDashboardData) {
    return this.http.post(this.apiUrl + 'api/Feedback/SearchFeedbackDataDashboard', 
    search,
    this.prepareOptions(search)).pipe(
      map((data: any) => {
        
        return data.body;
      }), catchError(this.handleError('getFeedbackDashboardData'))
    );
  }

}
